export default __webpack_public_path__ + "static/media/delete-icon-black.3ecd521b.svg";